import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @internal */ export const pageIdValidator = idValidator("page");
/** @internal */ export const pageValidator = T.model("page", T.object({
    typeName: T.literal("page"),
    id: pageIdValidator,
    name: T.string,
    index: T.string,
    meta: T.jsonValue
}));
/** @internal */ export const pageVersions = {
    AddMeta: 1
};
/** @internal */ export const pageMigrations = defineMigrations({
    currentVersion: pageVersions.AddMeta,
    migrators: {
        [pageVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        }
    }
});
/** @public */ export const PageRecordType = createRecordType("page", {
    validator: pageValidator,
    migrations: pageMigrations,
    scope: "document"
}).withDefaultProperties(()=>({
        meta: {}
    }));
/** @public */ export function isPageId(id) {
    return PageRecordType.isId(id);
}
